import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BusinessModal from './BusinessModal';

const { FiMenu } = FiIcons;

const Navbar = () => {
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const isActive = (path) => location.pathname === path;

  return (
    <>
      <nav className="bg-white/90 backdrop-blur-md sticky top-0 z-50 border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 bg-indigo-900 rounded-lg flex items-center justify-center text-white shadow-inner">
                <span className="font-playfair text-xl font-bold">M</span>
              </div>
              <span className="font-playfair text-2xl font-bold text-stone-800 tracking-tight">
                Massage <span className="text-indigo-800">World</span>
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link 
                to="/" 
                className={`${isActive('/') ? 'text-indigo-800 font-bold' : 'text-stone-600 hover:text-indigo-800'} font-medium transition-colors`}
              >
                Directory
              </Link>
              <Link 
                to="/neighborhoods" 
                className={`${isActive('/neighborhoods') ? 'text-indigo-800 font-bold' : 'text-stone-600 hover:text-indigo-800'} font-medium transition-colors`}
              >
                Neighborhoods
              </Link>
              <Link 
                to="/deals" 
                className={`${isActive('/deals') ? 'text-indigo-800 font-bold' : 'text-stone-600 hover:text-indigo-800'} font-medium transition-colors`}
              >
                Deals
              </Link>
              <button 
                onClick={() => setIsModalOpen(true)}
                className="bg-indigo-900 hover:bg-indigo-950 text-white px-6 py-2.5 rounded-full font-medium transition-all shadow-sm hover:shadow-md"
              >
                List Your Business
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
              <button className="text-stone-600 hover:text-indigo-900 focus:outline-none">
                <SafeIcon icon={FiMenu} className="h-6 w-6" />
              </button>
            </div>
          </div>
        </div>
      </nav>
      <BusinessModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Navbar;